import { render, staticRenderFns } from "./tachlog.vue?vue&type=template&id=11a1f496&scoped=true&"
import script from "./tachlog.vue?vue&type=script&lang=js&"
export * from "./tachlog.vue?vue&type=script&lang=js&"
import style0 from "./tachlog.vue?vue&type=style&index=0&id=11a1f496&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a1f496",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VScaleTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VContainer,VFadeTransition,VHover,VIcon,VRow,VScaleTransition})
